import { UilBars } from "@iconscout/react-unicons";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import HouseRoundedIcon from "@mui/icons-material/HouseRounded";
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import PowerSettingsNewRoundedIcon from '@mui/icons-material/PowerSettingsNewRounded';
import logo from "../../images/newuser.png";
import { userLogout } from "../../api/User";
import { WindowRounded } from "@mui/icons-material";

const Navbar = ({ sidebar, handleSidebar, role, userData }) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const dropdownRef = React.useRef(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLinkClick = () => {
    setDropdownOpen(false);
  };

  const handleLogout = async () => {
    try {
      const res = await userLogout();
      if (res.status == 'Success') {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = res.url;
      }
    } catch (error) {
      console.error("Error Logging out", error);
    }
  };

  return (
    <div className="container1 justify-content-between px-2 hide-on-print">
      <div className='d-flex col'>
        <div className="d-flex justify-content-start align-items-center me-2">
          <a className="bars text-white" onClick={handleSidebar}>
            <UilBars style={{ left: "1%", height: "30px", width: "30px" }} />
          </a>
        </div>
        <div className="userName mt-md-2">
          <h1 className='justify-content-start'>
            <strong> "State Finance Commission"</strong>
          </h1>
        </div>
      </div>
      <div className="ml-auto d-flex align-items-center">
        <Link to={"/vendor-payment-creation-payable"}>
          <HouseRoundedIcon
            className="mx-3"
            style={{ height: "1.8rem", width: "1.8rem" }}
          />
        </Link>
        <div className="nav-item dropdown" ref={dropdownRef}>
          <button
            onClick={toggleDropdown}
            className="nav-link dropdown-toggle text-muted waves-effect waves-dark pro-pic"
            aria-haspopup="true"
            aria-expanded={dropdownOpen}
          >
            <img className="mx-3" style={{ height: "2rem", width: "2rem" }} src={logo} alt="userLogo" />
          </button>
          <div
            className={`dropdown-menu user-dd animated ${dropdownOpen ? "flipInY show" : ""}`}
            style={{
              display: dropdownOpen ? "block" : "none",
              right: 0,
              left: "auto",
              marginTop: 0,
              paddingTop: 0,
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            <div
              className="d-flex no-block align-items-center p-15 bg-primary text-white m-b-10"
              style={{
                width: "17rem",
                backgroundColor: "#F1E8DE",
                margin: 0,
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            >
              <div>
                <img src={logo} alt="user" className="img-circle" width="60" />
              </div>
              <div className="mx-2">
                <h4 className="mx-2 my-2">
                  {userData?.data?.user_firstname}
                </h4>
                <p className="mx-2 my-2">{userData?.data?.user_email}</p>
              </div>
            </div>
            {role !== 20 && role !== 0 && (
              <Link className="dropdown-item" to="/profile-page" onClick={handleLinkClick}>
                <Person2OutlinedIcon /> My Profile
              </Link>
            )}
            <Link className="dropdown-item" onClick={handleLogout}>
              <PowerSettingsNewRoundedIcon /> Logout
            </Link>
            <div className="dropdown-divider"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;